// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup-content-container[data-v-6e0c9564] {\n  max-height: 50vh;\n}\n", ""]);
// Exports
module.exports = exports;
